'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ../node_modules/react/react.js
// module id = 15
// module chunks = 0